const isBrowser = typeof window !== 'undefined';

const Cookies = {
  getItem(key: string, isRaw: boolean): string | undefined {
    if (!isBrowser || !key) {
      return undefined;
    }

    if (isRaw) {
      return (
        document.cookie.replace(
          new RegExp(
            `(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(
              /[*+.-]/g,
              '\\$&',
            )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
          ),
          '$1',
        ) || undefined
      );
    }

    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            `(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(
              /[*+.-]/g,
              '\\$&',
            )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
          ),
          '$1',
        ),
      ) || undefined
    );
  },
  removeItem(key:string):void{
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.descomplica.com.br`;
  }
};

export default Cookies;
